import { useLocation, useNavigate } from "react-router-dom";
import useAuth from "../../../../hook/useAuth";
import useConfirm from "../../../../hook/useConfirm";
import useDelete from "../../../../hook/useDelete";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "../../../../config/api";
import { getLocation } from "../../../../services/Location";
import { getStatus } from "../../../../services/Appointment";
import { CustomSearchableDropdown } from "../../../../components/CustomSearchableDropdown";
import { validateMin } from "../../../../utils/validateMin";
import { PleasewaitPopup } from "../../../../components/PleasewaitPopup";
import Select from "react-select";


export const EditWheelInventory = () => {
    const navigate = useNavigate();
    const { auth }: any = useAuth();
    const idNumber = useLocation();
    const { setConfirmPopup, setData: setConfirmData }: any = useConfirm();
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();
    const [productId, setProductId] = useState<number>(0);
    const [productOptions, setProductOptions] = useState<any[]>([]);
    const [locationId, setLocationId] = useState<number>(0);
    const [locationOptions, setLocationOptions] = useState<any[]>([]);
    const [vendorIds, setVendorIds] = useState<any>();
    const [vendorOptions, setVendorOptions] = useState<any[]>([]);
    const [rackCode, setRackCode] = useState<string>("");
    const [shelf, setShelf] = useState<string>("");
    const [quantityOnHand, setQuantityOnHand] = useState<number>(0);
    const [reorderLevel, setReorderLevel] = useState<number>(0);
    const [reorderQuantity, setReorderQuantity] = useState<number>(0);
    const [costPrice, setCostPrice] = useState<number>(0);
    const [inHouse, setInHouse] = useState<string>("Yes");
    const [waitingTimeUnitOptions, setWaitingTimeUnitOptions] = useState<any[]>([]);
    const [waitingTimeValue, setWaitingTimeValue] = useState<number>(0);
    const [waitingTimeUnit, setWaitingTimeUnit] = useState<number>(0);
    const [salesTaxRate, setSalesTaxRate] = useState<number>(0);
    const [isFirstTime, setIsFirstTime] = useState<boolean>(true);
    const [isClone, setIsClone] = useState<boolean>(false);
    const [isSameInventoryExist, setIsSameInventoryExist] = useState<boolean>(false);
    const [isProductOrLocationChanged, setIsProductOrLocationChanged] = useState<boolean>(false);
    const [pleaseWaitPopup, setPleaseWaitPopup] = useState<boolean>(false);

    useEffect(() => {
        axios.get(`${baseURL}wheelProducts`)
            .then((response) => {
                setProductOptions(response?.data?.map((item: any) => {
                    return { value: item.wheelId, label: item.sku }
                }))


            }).catch(error => {
                setProductId(0);
                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getLocation()
            .then((data) => {
                setLocationOptions(() => data?.map((loc: any) => {
                    return {
                        value: loc?.id,
                        label: loc?.locationName
                    }
                }))


            })
            .catch((error) => {
                console.error(error)
            })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        axios.get(`${baseURL}vendors`)
            .then((response) => {
                setVendorOptions(response?.data?.map((item: any) => {
                    return { value: item.vendorId, label: item.vendorName }
                }))


            }).catch(error => {

                console.error(error);
            });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        getStatus("WaitingTimeUnit")
            .then((data) => {
                setWaitingTimeUnitOptions(() => data?.map((status: any) => {
                    return {
                        value: status.statusID,
                        statusValue: status.statusValue
                    }
                }))

            })
            .catch((error) => {
                console.error(error)
            })
    }, [])


    useEffect(() => {
        if (idNumber?.state && isFirstTime) {
            setPleaseWaitPopup(true);
            axios
                .get(`${baseURL}wheelInventories/${idNumber?.state}`)
                .then((response) => {
                    setProductId(response?.data?.wheelProductId);
                    setLocationId(response?.data?.locationId);
                    setRackCode(response?.data?.rackCode);
                    setShelf(response?.data?.shelf);
                    setQuantityOnHand(response?.data?.quantityOnHand);
                    setReorderLevel(response?.data?.reorderLevel);
                    setReorderQuantity(response?.data?.reorderQuantity);
                    setCostPrice(response?.data?.costPrice);
                    setInHouse(response?.data?.inHouse === true ? "Yes" : "No");
                    setWaitingTimeValue(response?.data?.waitingTimeValue);
                    setWaitingTimeUnit(response?.data?.waitingTimeUnit);
                    setSalesTaxRate(response?.data?.salesTaxRate);
                    setPleaseWaitPopup(false);
                    setIsFirstTime(false);
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idNumber, isFirstTime]);

    useEffect(() => {
        if (vendorOptions.length > 0 && !isFirstTime) {
            setPleaseWaitPopup(true);
            axios
                .get(`${baseURL}wheelInventoryVendorMappings/GetWheelInventoryVendorMappingsByInventoryId/${idNumber?.state}`)
                .then((response) => {
                    const selectedVendors = vendorOptions?.filter((_: any) => response?.data?.find((item: any) => item?.vendorId === _?.value));
                    setVendorIds(selectedVendors);
                    setPleaseWaitPopup(false);
                })
                .catch((error) => {
                    console.error(error)
                })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [vendorOptions, isFirstTime])

    useEffect(() => {
        if (isProductOrLocationChanged && productId && locationId) {
            axios
                .get(`${baseURL}wheelInventories/DoesSameWheelInventoryExistsForLocation/${locationId},${productId}`)
                .then((response) => {
                    setIsSameInventoryExist(response?.data);
                })
                .catch((error) => {
                    console.error(error)
                })
        }
        else {
            setIsSameInventoryExist(false);
        }
    }, [productId, locationId, isProductOrLocationChanged])

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (isClone && !isSameInventoryExist) {
            setPleaseWaitPopup(true);

            await axios
                .post(
                    `${baseURL}wheelInventories?userId=${auth?.id}`,
                    JSON.stringify({
                        wheelProductId: productId,
                        locationId,
                        rackCode,
                        shelf,
                        quantityOnHand,
                        reorderLevel,
                        reorderQuantity,
                        costPrice,
                        inHouse: inHouse === "Yes" ? true : false,
                        waitingTimeValue,
                        waitingTimeUnit,
                        salesTaxRate,
                    }),
                    {
                        headers: { "Content-Type": "application/json" },
                        withCredentials: false,
                    }
                )
                .then((response) => {
                    if (response?.data) {
                        if (vendorIds?.length > 0) {
                            const vendorIdsData = vendorIds?.map((item: any) =>
                            ({
                                wheelInventoryId: response?.data,
                                vendorId: item?.value
                            })
                            )
                            axios.post(
                                `${baseURL}wheelInventoryVendorMappings/CreateBulkWheelInventoryVendorMapping?userId=${auth?.id}`,
                                [...vendorIdsData],
                                {
                                    headers: { "Content-Type": "application/json" },
                                    withCredentials: false,
                                }
                            )
                                .then((res) => {
                                    setPleaseWaitPopup(false);
                                    navigate(-1);
                                }).catch((error) => {
                                    setPleaseWaitPopup(false);
                                    console.error("Error:", error);
                                });


                        }
                        else {
                            setPleaseWaitPopup(false);
                            navigate(-1);
                        }
                    }
                    else {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    }
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    console.error("Error:", error);
                });

        }
        else if (!isClone && !isSameInventoryExist) {
            setPleaseWaitPopup(true);

            await axios
                .put(
                    `${baseURL}wheelInventories?userId=${auth?.id}`,
                    JSON.stringify({
                        inventoryId: idNumber?.state,
                        wheelProductId: productId,
                        locationId,
                        rackCode,
                        shelf,
                        quantityOnHand,
                        reorderLevel,
                        reorderQuantity,
                        costPrice,
                        inHouse: inHouse === "Yes" ? true : false,
                        waitingTimeValue,
                        waitingTimeUnit,
                        salesTaxRate,
                    }),
                    {
                        headers: { "Content-Type": "application/json" },
                        withCredentials: false,
                    }
                )
                .then((response) => {
                    if (response?.data) {
                        axios.delete(
                            `${baseURL}wheelInventoryVendorMappings/DeleteWheelInventoryVendorMappingByInventoryId/${idNumber?.state}?userId=${auth?.id}`)
                            .then((res) => {
                                if (vendorIds?.length > 0) {
                                    const vendorIdsData = vendorIds?.map((item: any) =>
                                    ({
                                        wheelInventoryId: idNumber?.state,
                                        vendorId: item?.value
                                    })
                                    )
                                    axios.post(
                                        `${baseURL}wheelInventoryVendorMappings/CreateBulkWheelInventoryVendorMapping?userId=${auth?.id}`,
                                        [...vendorIdsData],
                                        {
                                            headers: { "Content-Type": "application/json" },
                                            withCredentials: false,
                                        }
                                    )
                                        .then((res) => {
                                            setPleaseWaitPopup(false);
                                            navigate(-1);
                                        }).catch((error) => {
                                            setPleaseWaitPopup(false);
                                            console.error("Error:", error);
                                        });


                                }
                                else {
                                    setPleaseWaitPopup(false);
                                    navigate(-1);
                                }
                            }).catch((error) => {
                                setPleaseWaitPopup(false);
                                console.error("Error:", error);
                            });
                    }
                    else {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    }
                })
                .catch((error) => {
                    setPleaseWaitPopup(false);
                    console.error("Error:", error);
                });
        }


    }

    const deletingInventory = async () => {
        setDeleteData({
            id: idNumber?.state,
            title: `Delete Inventory`,
            summary: `Are you sure you want to delete this inventory?`,
            isDelete: (callback: any) => {
                setPleaseWaitPopup(true);
                callback();

                axios
                    .delete(`${baseURL}wheelInventories?id=${idNumber?.state}&userId=${auth?.id}`)
                    .then(() => {
                        setPleaseWaitPopup(false);
                        navigate(-1);
                    })
                    .catch((error) => {
                        setConfirmData({
                            title: "Warning",
                            summary: error.response?.data || "Delete failed.",
                            confirmBtn: "Ok",
                            isConfirm: (cb: any) => cb(),
                        });

                        setConfirmPopup(true);
                        setPleaseWaitPopup(false);
                    });
            },
        });

        setDeletePopup(true);
    };

    return (
        <>
            <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                <div className="w-full bg-white p-4 rounded-md">
                    <div className={`flex justify-between items-center p-2 border-b`}>
                        <h2 className={`text-lg font-semibold`}>{isClone ? "Add Wheel Inventory" : "Edit Wheel Inventory"}</h2>
                        {
                            !isClone && (
                                <button className={`px-[12px] py-[10px] shadow-sm rounded-lg border bg-primary text-white flex items-center gap-1.5`}
                                    onClick={() => {
                                        setIsClone(true)
                                        setIsProductOrLocationChanged(true)
                                    }}
                                >
                                    <span className="text-xs font-medium">Clone Wheel Inventory</span>
                                </button>
                            )
                        }
                    </div>

                    {
                        isSameInventoryExist && (
                            <p className="text-[12px] mt-2 bg-[#FEDFDD] text-[#D92D20] text-left rounded-lg py-2 px-6">
                                This inventory already exists please change product or location.
                            </p>
                        )
                    }

                    <div className="mt-2 p-2">
                        <form onSubmit={(e) => handleSubmit(e)}>
                            <div className="w-full">
                                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-6">
                                    {/* First Column */}
                                    <div className="space-y-4">

                                        <CustomSearchableDropdown
                                            label="Product"
                                            options={productOptions}
                                            value={productId}
                                            setValue={setProductId}
                                            onChange={(value) => {
                                                setProductId(value)
                                                setIsProductOrLocationChanged(true)
                                            }}
                                            placeholder="Search Product"
                                            isRequired={true}
                                            inputClassNameProp="w-full p-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            labelClassNameProp="block text-xs font-medium text-secondary"
                                            selectedOptionLabel={productId ? String(productOptions?.find((item: any) => item?.value === productId)?.label) : ""}
                                        />


                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Vendors</label>
                                            <Select
                                                menuPortalTarget={document.body}
                                                styles={{
                                                    control: (baseStyles, state) => ({
                                                        ...baseStyles,
                                                        backgroundColor: "#ffffff",
                                                        color: "#2f3739",
                                                        borderRadius: '6px',
                                                        borderColor: state.isFocused ? "" : "#2f3739",
                                                        boxShadow: state.isFocused ? "0 0 0 1px #ea8616" : "",
                                                        "&: hover": {
                                                            borderColor: "#ea8616",
                                                        }

                                                    }),
                                                    menuPortal: (base) => ({
                                                        ...base,
                                                        zIndex: 9999
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        fontSize: "12px",
                                                        backgroundColor: "#ffffff",
                                                        color: "#2f3739",
                                                    }),
                                                    option: (base, state) => {
                                                        const isSelected = state.isSelected;
                                                        const isFocused = state.isFocused;
                                                        const selectedBg = "#ea8616";
                                                        const hoverBg = "#E6F0FA";
                                                        const defaultTextColor = "#000";

                                                        return {
                                                            ...base,
                                                            backgroundColor: isSelected
                                                                ? selectedBg
                                                                : isFocused
                                                                    ? hoverBg
                                                                    : "transparent",
                                                            color: isSelected ? "#fff" : defaultTextColor,
                                                            fontWeight: 500,
                                                            ':active': {
                                                                backgroundColor: isSelected ? selectedBg : hoverBg,
                                                            },
                                                        };
                                                    },
                                                    input: (base) => ({
                                                        ...base,
                                                        color: "#2f3739",

                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        color: "#2f3739",
                                                    }),
                                                }}
                                                isMulti
                                                className="basic-single"
                                                classNamePrefix="select"
                                                isLoading={false}
                                                isClearable={true}
                                                isRtl={false}
                                                isSearchable={true}
                                                name="vendorIds"
                                                value={vendorIds}
                                                onChange={setVendorIds}
                                                options={vendorOptions}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Shelf</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={shelf}
                                                placeholder="Shelf"
                                                onChange={(e) => setShelf(e.target.value)}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Reorder Level</label>
                                            <input
                                                type="number"
                                                min={0}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={reorderLevel}
                                                placeholder="Reorder Level"
                                                onChange={(e) => setReorderLevel(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Cost Price</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={costPrice}
                                                placeholder="Cost Price"
                                                onChange={(e) => setCostPrice(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Waiting Time Unit</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={waitingTimeUnit}
                                                onChange={(e) => setWaitingTimeUnit(Number(e.target.value))}
                                            >
                                                {
                                                    waitingTimeUnitOptions?.map((item: any, ind: number) => (
                                                        <option key={ind} value={item?.value}>{item?.statusValue}</option>
                                                    ))
                                                }

                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Sales Tax Rate</label>
                                            <input
                                                type="number"
                                                min={0}
                                                step={0.01}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={salesTaxRate}
                                                placeholder="Sales Tax Rate"
                                                onChange={(e) => setSalesTaxRate(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                    </div>

                                    {/* Second Column */}
                                    <div className="space-y-4">
                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Location</label>
                                            <select
                                                value={locationId}
                                                onChange={(e) => {
                                                    setLocationId(Number(e.target.value))
                                                    setIsProductOrLocationChanged(true)
                                                }}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                            >

                                                {locationOptions.map((loc: any, index: number) => (
                                                    <option key={index} value={loc?.value}>
                                                        {loc?.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Rack Code</label>
                                            <input
                                                type="text"
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={rackCode}
                                                placeholder="Rack Code"
                                                onChange={(e) => setRackCode(e.target.value)}
                                                required
                                            />
                                        </div>


                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Quantity On Hand</label>
                                            <input
                                                type="number"
                                                min={0}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={quantityOnHand}
                                                placeholder="Quantity On Hand"
                                                onChange={(e) => setQuantityOnHand(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Reorder Quantity</label>
                                            <input
                                                type="number"
                                                min={0}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={reorderQuantity}
                                                placeholder="Reorder Quantity"
                                                onChange={(e) => setReorderQuantity(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">InHouse</label>
                                            <select
                                                className={`w-full px-[8px] py-[8px] border border-secondary rounded-md outline-none focus:border-primary text-sm bg-transparent`}
                                                value={inHouse}
                                                onChange={(e) => setInHouse(e.target.value)}
                                            >
                                                <option value="Yes">Yes</option>
                                                <option value="No">No</option>

                                            </select>
                                        </div>

                                        <div>
                                            <label className="block text-xs font-medium text-secondary">Waiting Time Value</label>
                                            <input
                                                type="number"
                                                min={0}
                                                className="w-full px-[8px] py-[8px] border rounded-md border-secondary outline-none focus:border-primary text-sm text-secondary bg-transparent"
                                                value={waitingTimeValue}
                                                placeholder="Waiting Time Value"
                                                onChange={(e) => setWaitingTimeValue(validateMin(e.target.value, 0))}
                                                required
                                            />
                                        </div>

                                    </div>
                                </div>

                                {/* Buttons */}
                                <div className="flex flex-col sm:flex-row gap-4 mt-6">
                                    <button
                                        type="submit"
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-primary text-white cursor-pointer"
                                    >
                                        Save
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => {
                                            if (isClone) {
                                                setIsClone(false);
                                                setIsProductOrLocationChanged(false)
                                            }
                                            else {
                                                navigate(-1)
                                            }
                                        }}
                                        className="w-full sm:w-auto px-4 py-2 rounded bg-[#FFFFFF] text-primary cursor-pointer border border-primary"
                                    >
                                        Cancel
                                    </button>
                                    {
                                        !isClone && (
                                            <button
                                                type="button"
                                                onClick={() => deletingInventory()}
                                                className="w-full sm:w-auto px-4 py-2 rounded bg-red-500 text-white cursor-pointer border border-red-600"
                                            >
                                                Delete
                                            </button>
                                        )
                                    }

                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <PleasewaitPopup showPopup={pleaseWaitPopup} />
        </>
    )
}